const controller = function (
	$ionicLoading,
	$ionicModal,
	$ionicPlatform,
	$scope,
	$state,
	_,
	Basket,
	Customer,
	Invoice,
) {
	'ngInject'

	var vm = this;
	var invoices;

	vm.data = {};
	vm.data.country = 'NL';

	var a = 3500;

	function initialize() {
		vm.selection = [];
		vm.basket = Basket.get();
		vm.session = Customer.get();
		invoices = Invoice.total();
		vm.total = _.reduce(vm.basket, (mem, item) => {
			return mem + parseFloat(item.price);
		}, 0);

		vm.discount = 0;
		if (vm.session && vm.session.essent === 1) {
			vm.discount += 170;
		}
		if (vm.session && vm.session.ziggo === 1) {
			vm.discount += 200;
		}
		vm.groups = _.groupBy(vm.basket, item => item.product_id );
	}

	vm.invoice = function() {
		if (vm.selection.length === 0) {
			vm.selection = _.map(vm.basket, product => product.id);
			vm.sum = vm.basket.filter(item => vm.selection.indexOf(item.id) > -1)
			.map(item => parseFloat(item.price))
			.reduce((a, b) => {
				return a + b;
			}, 0);
		}
		$scope.modal = $ionicModal.fromTemplate('<invoice-modal modal="modal" selection="checkout.selection"></invoice-modal>', {
			scope: $scope,
			animation: 'slide-in-up',
			hardwareBackButtonClose: false,
			backdropClickToClose: false
		});
		$scope.modal.show();
		if (window.cordova) {
			cordova.plugins.Keyboard.disableScroll(false);
		}
	}


	vm.toggle = function(id) {
		if (vm.selection.indexOf(id) < 0) {
			vm.selection.push(id);
		} else {
			vm.selection.splice(vm.selection.indexOf(id), 1);
		}
		vm.sum = vm.basket.filter(item => vm.selection.indexOf(item.id) > -1)
		.map(item => parseFloat(item.price))
		.reduce((a, b) => {
			return a + b;
		}, 0);
	}

	vm.flush = function() {
		Basket.clear();
	}

	$scope.$on('BASKET_CHANGED', function(e) {
		initialize();
	});

	$scope.$on('INVOICES_CHANGED', function(e) {
		vm.basket = Basket.get();
		invoices = Invoice.total();
		if (vm.basket.length === 0 && invoices > 0) {
			$state.go('tab.invoices');
		}
	});

	$scope.$on('modal.removed', function() {
		if (window.cordova) {
			cordova.plugins.Keyboard.disableScroll(true);
		}
	});

	$scope.$on('$ionicView.enter', function(e) {
		initialize();
	});
}

export default controller


// WEBPACK FOOTER //
// ./app/components/checkout/checkout.controller.js